import React, { useEffect, useRef, useState } from 'react';
import { getSettings, setSetting, translateGifts, uploadAgencyLogo, getPeriods, testDropboxConnection, getDropboxAuthUrl, dropboxExchangeCode, getMaintenanceStatus, runMaintenanceAction, type MaintenanceStatus,
  getElevenLabsStatus, setElevenLabsKey, getElevenLabsVoices, ttsElevenLabs, type ElevenLabsVoice,
  getSmsStatus, sendSms, type SmsStatus,
  getConnectionLogs, type ConnectionLog } from './api';

type MainTab = 'infos' | 'objectifs' | 'remuneration' | 'apps' | 'sms' | 'maj';
type AppSubTab = 'chatgpt' | 'dropbox' | 'elevenlabs';

interface SettingsProps { isMobile?: boolean; onLogoUpdated?: () => void; }

export default function Settings({ isMobile, onLogoUpdated }: SettingsProps) {
  const [mainTab, setMainTab] = useState<MainTab>('infos');

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#f8fafc' }}>
      {/* Header */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', flexShrink: 0 }}>
        <div style={{ padding: isMobile ? '16px 16px 0' : '24px 32px 0' }}>
          <h1 style={{ margin: 0, color: '#0f172a', fontSize: isMobile ? 18 : 22, fontWeight: 700 }}>Paramètres</h1>
          {!isMobile && <p style={{ margin: '4px 0 16px', color: '#64748b', fontSize: 14 }}>Configuration de l'agence et des intégrations</p>}

          {!isMobile && (
            <div style={{ display: 'flex', gap: 0 }}>
              <TabBtn active={mainTab === 'infos'} onClick={() => setMainTab('infos')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Infos
              </TabBtn>
              <TabBtn active={mainTab === 'objectifs'} onClick={() => setMainTab('objectifs')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Objectifs
              </TabBtn>
              <TabBtn active={mainTab === 'remuneration'} onClick={() => setMainTab('remuneration')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Rémunération TikTok
              </TabBtn>
              <TabBtn active={mainTab === 'apps'} onClick={() => setMainTab('apps')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
                Applications
              </TabBtn>
              <TabBtn active={mainTab === 'sms'} onClick={() => setMainTab('sms')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 3v-3z" />
                </svg>
                SMS
              </TabBtn>
              <TabBtn active={mainTab === 'maj'} onClick={() => setMainTab('maj')}>
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ marginRight: 6 }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Serveurs
              </TabBtn>
            </div>
          )}
          {isMobile && <div style={{ marginBottom: 12 }} />}
        </div>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '16px 16px' : '28px 32px', paddingBottom: isMobile ? 58 : undefined }}>
        {mainTab === 'infos' && <AgencyInfoTab isMobile={isMobile} onLogoUpdated={onLogoUpdated} />}
        {mainTab === 'objectifs' && <ObjectifsTab isMobile={isMobile} />}
        {mainTab === 'remuneration' && <RemunerationTab isMobile={isMobile} />}
        {mainTab === 'apps' && <ApplicationsTab isMobile={isMobile} />}
        {mainTab === 'sms' && <SmsTab isMobile={isMobile} />}
        {mainTab === 'maj' && <ServeursTab isMobile={isMobile} />}
      </div>

      {/* Mobile bottom nav */}
      {isMobile && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100, background: '#fff', borderTop: '1px solid #e2e8f0', display: 'flex', alignItems: 'stretch', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
          <button onClick={() => setMainTab('infos')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'infos' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'infos' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'infos' ? 600 : 400 }}>Infos</span>
          </button>
          <button onClick={() => setMainTab('objectifs')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'objectifs' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'objectifs' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'objectifs' ? 600 : 400 }}>Objectifs</span>
          </button>
          <button onClick={() => setMainTab('remuneration')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'remuneration' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'remuneration' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'remuneration' ? 600 : 400 }}>Rémunération</span>
          </button>
          <button onClick={() => setMainTab('apps')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'apps' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'apps' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'apps' ? 600 : 400 }}>Applications</span>
          </button>
          <button onClick={() => setMainTab('sms')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'sms' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'sms' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 3v-3z" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'sms' ? 600 : 400 }}>SMS</span>
          </button>
          <button onClick={() => setMainTab('maj')} style={{ flex: 1, padding: '8px 4px 6px', border: 'none', background: 'transparent', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, color: mainTab === 'maj' ? '#2563eb' : '#64748b', cursor: 'pointer', borderTop: `2px solid ${mainTab === 'maj' ? '#2563eb' : 'transparent'}` }}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <span style={{ fontSize: 10, fontWeight: mainTab === 'maj' ? 600 : 400 }}>Serveurs</span>
          </button>
        </div>
      )}
    </div>
  );
}

// ── Onglet Infos agence ───────────────────────────────────

function AgencyInfoTab({ isMobile, onLogoUpdated }: { isMobile?: boolean; onLogoUpdated?: () => void }) {
  const [form, setForm] = useState({
    agency_name: '',
    agency_address: '',
    agency_postal_code: '',
    agency_city: '',
    agency_phone: '',
    agency_email: '',
  });
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [logoUploading, setLogoUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const logoRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    getSettings().then(r => {
      const d = r.data;
      setForm({
        agency_name: d['agency_name'] || '',
        agency_address: d['agency_address'] || '',
        agency_postal_code: d['agency_postal_code'] || '',
        agency_city: d['agency_city'] || '',
        agency_phone: d['agency_phone'] || '',
        agency_email: d['agency_email'] || '',
      });
      setLogoUrl(d['agency_logo_url'] || null);
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await Promise.all(
        (Object.entries(form) as [string, string][]).map(([k, v]) => setSetting(k, v))
      );
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch {}
    setSaving(false);
  };

  const handleLogoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; if (!file) return;
    setLogoUploading(true);
    try {
      const r = await uploadAgencyLogo(file);
      setLogoUrl(r.data.logo_url);
      onLogoUpdated?.();
    } catch {}
    setLogoUploading(false);
    e.target.value = '';
  };

  return (
    <div style={{ maxWidth: 580, display: 'flex', flexDirection: 'column', gap: 16 }}>

      {/* Logo */}
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
        <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 14 }}>Logo de l'agence</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <div style={{ width: 80, height: 80, borderRadius: 12, background: '#f8fafc', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0, position: 'relative' }}>
            {logoUploading ? (
              <span style={{ color: '#94a3b8', fontSize: 11 }}>…</span>
            ) : logoUrl ? (
              <img src={logoUrl} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 6 }}
                onError={e => (e.target as HTMLImageElement).style.display = 'none'} />
            ) : (
              <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="#cbd5e1" strokeWidth="1.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
            )}
          </div>
          <div>
            <button onClick={() => logoRef.current?.click()} style={btnSecondary}>
              {logoUrl ? 'Changer le logo' : 'Importer un logo'}
            </button>
            <div style={{ color: '#94a3b8', fontSize: 11, marginTop: 4 }}>PNG, JPG, WebP ou SVG</div>
            <input ref={logoRef} type="file" accept=".png,.jpg,.jpeg,.webp,.svg" style={{ display: 'none' }} onChange={handleLogoChange} />
          </div>
        </div>
      </div>

      {/* Informations */}
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '18px 20px' }}>
        <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 16 }}>Informations de l'agence</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Field label="Nom de l'agence">
            <input style={inputLight} value={form.agency_name} placeholder="NS Live Agency"
              onChange={e => setForm(f => ({ ...f, agency_name: e.target.value }))} />
          </Field>

          <Field label="Adresse">
            <input style={inputLight} value={form.agency_address} placeholder="12 rue de la Paix"
              onChange={e => setForm(f => ({ ...f, agency_address: e.target.value }))} />
          </Field>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '140px 1fr', gap: 10 }}>
            <Field label="Code postal">
              <input style={inputLight} value={form.agency_postal_code} placeholder="75001"
                onChange={e => setForm(f => ({ ...f, agency_postal_code: e.target.value }))} />
            </Field>
            <Field label="Ville">
              <input style={inputLight} value={form.agency_city} placeholder="Paris"
                onChange={e => setForm(f => ({ ...f, agency_city: e.target.value }))} />
            </Field>
          </div>

          <Field label="Téléphone">
            <input style={inputLight} type="tel" value={form.agency_phone} placeholder="+33 1 23 45 67 89"
              onChange={e => setForm(f => ({ ...f, agency_phone: e.target.value }))} />
          </Field>

          <Field label="Adresse e-mail">
            <input style={inputLight} type="email" value={form.agency_email} placeholder="contact@agence.fr"
              onChange={e => setForm(f => ({ ...f, agency_email: e.target.value }))} />
          </Field>
        </div>

        <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={handleSave} disabled={saving}
            style={{ padding: '9px 22px', borderRadius: 8, border: 'none', background: saved ? '#16a34a' : '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.7 : 1, transition: 'background 0.2s' }}>
            {saving ? 'Sauvegarde…' : saved ? '✓ Sauvegardé' : 'Sauvegarder'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Onglet Applications ───────────────────────────────────

function ApplicationsTab({ isMobile }: { isMobile?: boolean }) {
  const [subTab, setSubTab] = useState<AppSubTab>('chatgpt');
  const [apiKey, setApiKey] = useState('');
  const [masked, setMasked] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [translating, setTranslating] = useState(false);
  const [translateResult, setTranslateResult] = useState<{ ok?: string; err?: string } | null>(null);
  const appTabs: { key: AppSubTab; label: string }[] = [
    { key: 'chatgpt', label: 'ChatGPT' },
    { key: 'dropbox', label: 'Dropbox' },
    { key: 'elevenlabs', label: 'ElevenLabs' },
  ];

  useEffect(() => {
    getSettings().then(r => {
      const v = r.data['openai_api_key'];
      setMasked(v ? '••••' + v.slice(-4) : null);
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    if (!apiKey.trim()) return;
    setSaving(true);
    try {
      await setSetting('openai_api_key', apiKey.trim());
      setSaved(true);
      setMasked('••••' + apiKey.slice(-4));
      setApiKey('');
      setTimeout(() => setSaved(false), 3000);
    } catch { } finally { setSaving(false); }
  };

  const handleTranslate = async () => {
    setTranslating(true);
    setTranslateResult(null);
    try {
      const r = await translateGifts();
      const n = r.data.translated;
      setTranslateResult({ ok: r.data.message || `${n} cadeau${n > 1 ? 'x' : ''} traduit${n > 1 ? 's' : ''} en français` });
    } catch (e: any) {
      setTranslateResult({ err: e?.response?.data?.detail || 'Erreur lors de la traduction' });
    } finally { setTranslating(false); }
  };

  return (
    <div style={{ maxWidth: 660, width: '100%', display: 'flex', flexDirection: 'column', gap: 20, boxSizing: 'border-box' }}>
      {isMobile ? (
        <select
          value={subTab}
          onChange={e => setSubTab(e.target.value as AppSubTab)}
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 14, fontWeight: 600, outline: 'none' }}
        >
          {appTabs.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
      ) : (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {appTabs.map(t => (
            <button key={t.key} onClick={() => setSubTab(t.key)} style={{
              padding: '7px 14px', borderRadius: 8, border: '1px solid',
              borderColor: subTab === t.key ? '#2563eb' : '#e2e8f0',
              background: subTab === t.key ? '#eff6ff' : '#fff',
              color: subTab === t.key ? '#2563eb' : '#64748b',
              fontSize: 13, fontWeight: subTab === t.key ? 600 : 400, cursor: 'pointer',
            }}>
              {t.label}
            </button>
          ))}
        </div>
      )}

      {/* Content */}
      <div style={{ minWidth: 0 }}>
        {subTab === 'elevenlabs' && <ElevenLabsSubTab />}
        {subTab === 'dropbox' && <DropboxSubTab />}
        {subTab === 'chatgpt' && (
          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <div style={{ color: '#0f172a', fontSize: 15, fontWeight: 700, marginBottom: 4 }}>OpenAI — ChatGPT</div>
              <div style={{ color: '#64748b', fontSize: 13, lineHeight: 1.6 }}>
                Utilisé pour traduire automatiquement les noms des cadeaux TikTok en français dans la bibliothèque.
              </div>
            </div>

            {masked && (
              <div style={{ padding: '8px 12px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                <span style={{ color: '#16a34a', fontSize: 12 }}>✓</span>
                <span style={{ color: '#16a34a', fontSize: 12, fontFamily: 'monospace', overflowWrap: 'anywhere', minWidth: 0 }}>Clé configurée : {masked}</span>
              </div>
            )}

            <div>
              <div style={{ color: '#374151', fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
                {masked ? 'Remplacer la clé API' : 'Clé API OpenAI'}
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <input type="password" placeholder="sk-..." value={apiKey}
                  onChange={e => setApiKey(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSave()}
                  style={{ flex: 1, minWidth: 140, boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 13, outline: 'none' }}
                />
                <button onClick={handleSave} disabled={saving || !apiKey.trim()}
                  style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: saved ? '#16a34a' : '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: apiKey.trim() ? 'pointer' : 'not-allowed', opacity: !apiKey.trim() ? 0.5 : 1, whiteSpace: 'nowrap' }}>
                  {saving ? '…' : saved ? '✓ Sauvé' : 'Sauvegarder'}
                </button>
              </div>
            </div>

            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 16 }}>
              <div style={{ color: '#0f172a', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Traduction des cadeaux</div>
              <div style={{ color: '#64748b', fontSize: 13, marginBottom: 14, lineHeight: 1.6 }}>
                Traduit tous les noms de cadeaux anglais vers le français. Les traductions s'affichent dans le sélecteur de cadeaux.
              </div>

              {translateResult && (
                <div style={{ marginBottom: 12, padding: '8px 12px', borderRadius: 8, background: translateResult.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${translateResult.ok ? '#bbf7d0' : '#fecaca'}`, color: translateResult.ok ? '#16a34a' : '#dc2626', fontSize: 13 }}>
                  {translateResult.ok || translateResult.err}
                </div>
              )}

              <button onClick={handleTranslate} disabled={translating || !masked}
                style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e2e8f0', background: masked ? '#fff' : '#f8fafc', color: translating ? '#94a3b8' : '#374151', fontSize: 13, fontWeight: 500, cursor: (translating || !masked) ? 'not-allowed' : 'pointer', opacity: !masked ? 0.4 : 1, display: 'flex', alignItems: 'center', gap: 8 }}>
                {translating ? (
                  <><span style={{ display: 'inline-block', animation: 'spin 1s linear infinite', fontSize: 14 }}>⟳</span>Traduction en cours…</>
                ) : '🌍 Traduire les cadeaux en français'}
              </button>
              {!masked && <div style={{ color: '#94a3b8', fontSize: 11, marginTop: 8 }}>Configure d'abord la clé API ci-dessus.</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── ElevenLabs Sub-Tab (TTS pour la lecture des questions) ──

function ElevenLabsSubTab() {
  const [apiKey, setApiKey] = useState('');
  const [masked, setMasked] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState<{ ok?: string; err?: string } | null>(null);

  const [voices, setVoices] = useState<ElevenLabsVoice[]>([]);
  const [loadingVoices, setLoadingVoices] = useState(false);
  const [voicesErr, setVoicesErr] = useState<string | null>(null);
  const [testVoiceId, setTestVoiceId] = useState('');
  const [testText, setTestText] = useState("Bonjour, c'est un test de la voix pour la lecture des questions.");
  const [testing, setTesting] = useState(false);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);

  const loadStatus = async () => {
    try {
      const r = await getElevenLabsStatus();
      setMasked(r.data.masked || null);
    } catch {}
  };
  const loadVoices = async () => {
    setLoadingVoices(true); setVoicesErr(null);
    try {
      const r = await getElevenLabsVoices();
      setVoices(r.data.voices || []);
      if (r.data.voices?.length && !testVoiceId) setTestVoiceId(r.data.voices[0].voice_id);
    } catch (e: any) {
      setVoicesErr(e?.response?.data?.detail || 'Impossible de charger les voix');
    } finally {
      setLoadingVoices(false);
    }
  };

  useEffect(() => { loadStatus(); }, []);
  useEffect(() => { if (masked) loadVoices(); /* eslint-disable-next-line */ }, [masked]);

  const handleSave = async () => {
    if (!apiKey.trim()) return;
    setSaving(true); setSavedMsg(null);
    try {
      const r = await setElevenLabsKey(apiKey.trim());
      setMasked(r.data.masked || null);
      setApiKey('');
      setSavedMsg({ ok: 'Clé enregistrée' });
      setTimeout(() => setSavedMsg(null), 3000);
      loadVoices();
    } catch (e: any) {
      setSavedMsg({ err: e?.response?.data?.detail || 'Erreur' });
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    if (!testVoiceId || !testText.trim()) return;
    setTesting(true);
    try {
      const r = await ttsElevenLabs(testVoiceId, testText.trim());
      const url = URL.createObjectURL(r.data as Blob);
      if (audioRef.current) { audioRef.current.pause(); }
      const audio = new Audio(url);
      audioRef.current = audio;
      audio.play();
    } catch (e: any) {
      alert('Erreur TTS : ' + (e?.response?.data?.detail || e.message || ''));
    } finally {
      setTesting(false);
    }
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{ color: '#0f172a', fontSize: 15, fontWeight: 700, marginBottom: 4 }}>ElevenLabs — Synthèse vocale</div>
        <div style={{ color: '#64748b', fontSize: 13, lineHeight: 1.6 }}>
          Utilisé pour <b>lire à voix haute les questions</b> de la file d'attente pendant les lives.
        </div>
      </div>

      {masked && (
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ color: '#16a34a', fontSize: 16 }}>✓</span>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#15803d', fontSize: 13, fontWeight: 600 }}>Clé configurée</div>
            <div style={{ color: '#64748b', fontSize: 12, fontFamily: 'monospace' }}>{masked}</div>
          </div>
        </div>
      )}

      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
          {masked ? 'Remplacer la clé API' : 'Clé API ElevenLabs'}
        </label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input type="password" value={apiKey} onChange={e => setApiKey(e.target.value)}
            placeholder="sk_xxxxxxxxxxxxxxxxxxxxxxxxxxx"
            style={{ flex: 1, padding: '9px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, fontFamily: 'monospace' }} />
          <button onClick={handleSave} disabled={saving || !apiKey.trim()}
            style={{ background: apiKey.trim() ? '#0ea5e9' : '#cbd5e1', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 600, cursor: apiKey.trim() ? 'pointer' : 'not-allowed' }}>
            {saving ? 'Vérification…' : 'Enregistrer'}
          </button>
        </div>
        {savedMsg?.ok && <div style={{ color: '#16a34a', fontSize: 12, marginTop: 6 }}>✓ {savedMsg.ok}</div>}
        {savedMsg?.err && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 6 }}>✗ {savedMsg.err}</div>}
        <div style={{ color: '#94a3b8', fontSize: 11, marginTop: 6 }}>
          Récupère ta clé sur <a href="https://elevenlabs.io/app/settings/api-keys" target="_blank" rel="noreferrer" style={{ color: '#0ea5e9' }}>elevenlabs.io/app/settings/api-keys</a>.
        </div>
      </div>

      {/* Voices + Test */}
      {masked && (
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a' }}>🎙 Tester une voix</div>
            <button onClick={loadVoices} disabled={loadingVoices}
              style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: 6, padding: '4px 10px', fontSize: 11, color: '#64748b', cursor: 'pointer' }}>
              {loadingVoices ? 'Chargement…' : '↻ Rafraîchir'}
            </button>
          </div>
          {voicesErr && <div style={{ color: '#dc2626', fontSize: 12 }}>{voicesErr}</div>}
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569' }}>
            Voix
            <select value={testVoiceId} onChange={e => setTestVoiceId(e.target.value)}
              style={{ width: '100%', marginTop: 4, padding: '9px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, background: '#fff' }}>
              {voices.length === 0 && <option value="">— aucune voix —</option>}
              {voices.map(v => (
                <option key={v.voice_id} value={v.voice_id}>
                  {v.name}{v.labels?.gender ? ` · ${v.labels.gender}` : ''}{v.labels?.accent ? ` · ${v.labels.accent}` : ''}{v.category ? ` (${v.category})` : ''}
                </option>
              ))}
            </select>
          </label>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569' }}>
            Phrase de test (FR)
            <textarea value={testText} onChange={e => setTestText(e.target.value)} rows={3}
              style={{ width: '100%', marginTop: 4, padding: '9px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', resize: 'vertical' }} />
          </label>
          <button onClick={handleTest} disabled={testing || !testVoiceId || !testText.trim()}
            style={{ background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 13, fontWeight: 700, cursor: testing ? 'wait' : 'pointer', alignSelf: 'flex-start' }}>
            {testing ? '🔊 Génération…' : '🔊 Écouter le test'}
          </button>
        </div>
      )}
    </div>
  );
}

// ── Dropbox Sub-Tab ──────────────────────────────────────

function DropboxSubTab() {
  const [token, setToken] = useState('');
  const [masked, setMasked] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState<{ ok?: string; err?: string } | null>(null);
  const [appKey, setAppKey] = useState('');
  const [appSecret, setAppSecret] = useState('');
  const [permMasked, setPermMasked] = useState(false);
  const [savingPerm, setSavingPerm] = useState(false);
  const [savedPerm, setSavedPerm] = useState(false);
  const [authCode, setAuthCode] = useState('');
  const [exchanging, setExchanging] = useState(false);
  const [oauthMsg, setOauthMsg] = useState<{ ok?: string; err?: string } | null>(null);

  const handleAuthorize = async () => {
    setOauthMsg(null);
    try {
      const r = await getDropboxAuthUrl();
      window.open(r.data.url, '_blank', 'noopener');
    } catch (e: any) {
      setOauthMsg({ err: e?.response?.data?.detail || "Enregistre d'abord l'App key + secret." });
    }
  };

  const handleExchange = async () => {
    if (!authCode.trim()) return;
    setExchanging(true); setOauthMsg(null);
    try {
      const r = await dropboxExchangeCode(authCode.trim());
      setPermMasked(true);
      setAuthCode('');
      setOauthMsg({ ok: `Connexion permanente activée ✓ (${r.data.account})` });
    } catch (e: any) {
      setOauthMsg({ err: e?.response?.data?.detail || 'Code invalide ou expiré.' });
    } finally { setExchanging(false); }
  };

  useEffect(() => {
    getSettings().then(r => {
      const v = r.data['dropbox_token'];
      if (v) setMasked('••••' + v.slice(-4));
      if (r.data['dropbox_app_key'] && r.data['dropbox_refresh_token']) setPermMasked(true);
    }).catch(() => {});
  }, []);

  const handleSavePerm = async () => {
    if (!appKey.trim() || !appSecret.trim()) return;
    setSavingPerm(true);
    try {
      await setSetting('dropbox_app_key', appKey.trim());
      await setSetting('dropbox_app_secret', appSecret.trim());
      setSavedPerm(true);
      setTimeout(() => setSavedPerm(false), 3000);
    } catch { } finally { setSavingPerm(false); }
  };

  const handleSave = async () => {
    if (!token.trim()) return;
    setSaving(true);
    try {
      await setSetting('dropbox_token', token.trim());
      setMasked('••••' + token.slice(-4));
      setToken('');
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { } finally { setSaving(false); }
  };

  const handleTest = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const r = await testDropboxConnection();
      const w = (r.data as any).warning;
      setTestResult({ ok: `Connecté en tant que ${r.data.account} (${(r.data as any).mode === 'refresh' ? 'connexion permanente ✓' : 'token simple'})${w ? ' — ⚠ ' + w : ''}` });
    } catch (e: any) {
      setTestResult({ err: e?.response?.data?.detail || 'Connexion impossible. Vérifiez le token.' });
    } finally { setTesting(false); }
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{ color: '#0f172a', fontSize: 15, fontWeight: 700, marginBottom: 4 }}>Dropbox</div>
        <div style={{ color: '#64748b', fontSize: 13, lineHeight: 1.6 }}>
          Token d'accès utilisé pour stocker les fichiers envoyés lors des candidatures aux concours.
        </div>
      </div>

      {masked && (
        <div style={{ padding: '8px 12px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <span style={{ color: '#16a34a', fontSize: 12 }}>✓</span>
          <span style={{ color: '#16a34a', fontSize: 12, fontFamily: 'monospace', overflowWrap: 'anywhere', minWidth: 0 }}>Token configuré : {masked}</span>
        </div>
      )}

      <div>
        <div style={{ color: '#374151', fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
          {masked ? 'Remplacer le token' : 'Token d\'accès Dropbox'}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input
            type="password"
            placeholder="sl.B..."
            value={token}
            onChange={e => setToken(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSave()}
            style={{ flex: 1, minWidth: 140, boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 13, outline: 'none' }}
          />
          <button
            onClick={handleSave}
            disabled={saving || !token.trim()}
            style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: saved ? '#16a34a' : '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: token.trim() ? 'pointer' : 'not-allowed', opacity: !token.trim() ? 0.5 : 1, whiteSpace: 'nowrap' }}
          >
            {saving ? '…' : saved ? '✓ Sauvé' : 'Sauvegarder'}
          </button>
        </div>
      </div>

      <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 16 }}>
        <div style={{ color: '#0f172a', fontSize: 13, fontWeight: 700, marginBottom: 4 }}>
          🔒 Connexion permanente (recommandé)
        </div>
        <div style={{ color: '#64748b', fontSize: 12, lineHeight: 1.6, marginBottom: 10 }}>
          Le token simple ci-dessus (<code>sl.</code>) expire au bout de ~4 h. Pour un upload <strong>permanent</strong> :
          renseigne ton <strong>App key</strong> + <strong>App secret</strong> (Dropbox App Console → permissions
          <code>files.content.write</code> + <code>sharing.write</code>), puis autorise l'application ci-dessous.
          Pas besoin de générer toi-même le refresh token : on s'en occupe.
        </div>
        {permMasked && (
          <div style={{ padding: '8px 12px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, marginBottom: 10, color: '#16a34a', fontSize: 12 }}>
            ✓ Connexion permanente active (refresh token configuré)
          </div>
        )}

        <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>1. Identifiants de l'app</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 8 }}>
          <input type="text" placeholder="App key" value={appKey} onChange={e => setAppKey(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, outline: 'none' }} />
          <input type="password" placeholder="App secret" value={appSecret} onChange={e => setAppSecret(e.target.value)}
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, outline: 'none' }} />
        </div>
        <button onClick={handleSavePerm}
          disabled={savingPerm || !appKey.trim() || !appSecret.trim()}
          style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: savedPerm ? '#16a34a' : '#7c3aed', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: (!appKey.trim() || !appSecret.trim()) ? 0.5 : 1, marginBottom: 16 }}>
          {savingPerm ? '…' : savedPerm ? '✓ Enregistré' : 'Enregistrer App key + secret'}
        </button>

        <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>2. Autoriser Dropbox</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <button onClick={handleAuthorize}
            style={{ padding: '9px 16px', borderRadius: 8, border: '1px solid #7c3aed', background: '#fff', color: '#7c3aed', fontSize: 13, fontWeight: 600, cursor: 'pointer', alignSelf: 'flex-start' }}>
            🔗 Ouvrir la page d'autorisation Dropbox
          </button>
          <div style={{ fontSize: 12, color: '#64748b' }}>
            Connecte-toi, clique « Autoriser », copie le <strong>code</strong> affiché, colle-le ici :
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="text" placeholder="Code d'autorisation" value={authCode} onChange={e => setAuthCode(e.target.value)}
              style={{ flex: 1, minWidth: 140, boxSizing: 'border-box', padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, outline: 'none' }} />
            <button onClick={handleExchange} disabled={exchanging || !authCode.trim()}
              style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: !authCode.trim() ? 0.5 : 1, whiteSpace: 'nowrap' }}>
              {exchanging ? '…' : 'Valider le code'}
            </button>
          </div>
          {oauthMsg && (
            <div style={{ padding: '8px 12px', borderRadius: 8, fontSize: 12, background: oauthMsg.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${oauthMsg.ok ? '#bbf7d0' : '#fecaca'}`, color: oauthMsg.ok ? '#16a34a' : '#dc2626' }}>
              {oauthMsg.ok || oauthMsg.err}
            </div>
          )}
        </div>
      </div>

      {(masked || permMasked) && (
        <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 16 }}>
          <div style={{ color: '#0f172a', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Tester la connexion</div>

          {testResult && (
            <div style={{ marginBottom: 12, padding: '8px 12px', borderRadius: 8, background: testResult.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${testResult.ok ? '#bbf7d0' : '#fecaca'}`, color: testResult.ok ? '#16a34a' : '#dc2626', fontSize: 13 }}>
              {testResult.ok || testResult.err}
            </div>
          )}

          <button
            onClick={handleTest}
            disabled={testing}
            style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#374151', fontSize: 13, fontWeight: 500, cursor: testing ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
          >
            {testing ? '⟳ Connexion en cours…' : '📦 Tester la connexion Dropbox'}
          </button>
        </div>
      )}
    </div>
  );
}

// ── Helpers ───────────────────────────────────────────────

// ── Onglet Serveurs (sous-onglets MAJ + Logs) ─────────────

// ── Onglet SMS (passerelle HAT 4G) ───────────────────────
function SmsTab({ isMobile }: { isMobile?: boolean }) {
  const [status, setStatus] = useState<SmsStatus | null>(null);
  const [to, setTo] = useState('');
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');

  const refresh = () => {
    getSmsStatus().then(r => setStatus(r.data)).catch(() => setStatus(null));
  };
  useEffect(() => {
    refresh();
    const iv = setInterval(refresh, 8000);
    return () => clearInterval(iv);
  }, []);

  const send = async () => {
    if (!to.trim() || !text.trim()) return;
    setSending(true); setMsg('');
    try { await sendSms(to.trim(), text.trim()); setMsg('✅ SMS mis en file d\'envoi.'); setText(''); setTimeout(refresh, 1500); }
    catch (e: any) { setMsg('❌ ' + (e?.response?.data?.detail || 'Échec')); }
    setSending(false);
  };

  const ok = status?.modem && status?.registered;

  return (
    <div style={{ maxWidth: 720, display: 'flex', flexDirection: 'column', gap: 16 }}>
      {/* Statut modem */}
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: status?.modem ? 10 : 0 }}>
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: ok ? '#16a34a' : status?.modem ? '#f59e0b' : '#dc2626', flexShrink: 0 }} />
          <span style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>
            {ok ? 'Passerelle SMS opérationnelle' : status?.modem ? 'Modem détecté (non enregistré)' : 'Modem non détecté'}
          </span>
        </div>
        {status?.modem ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, fontSize: 12.5, color: '#475569' }}>
            <span>📶 Signal : <b>{status.signal != null ? status.signal + '%' : '—'}</b></span>
            <span>📡 Opérateur : <b>{status.operator || '—'}</b></span>
            <span>Enregistré : <b>{status.registered ? 'oui' : 'non'}</b></span>
            <span>Non lus : <b>{status.unread}</b></span>
            <span>En file : <b>{status.pending}</b></span>
          </div>
        ) : (
          <div style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 6 }}>
            Aucun HAT 4G sur ce serveur. La passerelle tourne sur le serveur équipé du modem (SRV‑NSLIVE).
          </div>
        )}
      </div>

      {/* Envoi */}
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 18 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 12 }}>Envoyer un SMS</div>
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 8, marginBottom: 8 }}>
          <input value={to} onChange={e => setTo(e.target.value)} placeholder="+33XXXXXXXXX"
            style={{ width: isMobile ? '100%' : 170, boxSizing: 'border-box', padding: '9px 11px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }} />
          <input value={text} onChange={e => setText(e.target.value)} placeholder="Votre message…" onKeyDown={e => e.key === 'Enter' && send()}
            style={{ flex: 1, boxSizing: 'border-box', padding: '9px 11px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }} />
          <button onClick={send} disabled={sending || !to.trim() || !text.trim()}
            style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: (sending || !to.trim() || !text.trim()) ? 0.5 : 1, whiteSpace: 'nowrap' }}>
            {sending ? '…' : 'Envoyer'}
          </button>
        </div>
        {msg && <div style={{ fontSize: 12.5, color: msg.startsWith('✅') ? '#16a34a' : '#dc2626' }}>{msg}</div>}
      </div>

      {/* Gestion complète sur le service dédié */}
      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, fontSize: 12.5, color: '#475569', lineHeight: 1.5 }}>
        📟 Les <b>messages reçus</b>, l'historique et les <b>clés API</b> (willinvest, nca‑europe…)
        se gèrent désormais sur la <b>passerelle SMS dédiée</b> :{' '}
        <a href="https://gsm.rdpc.fr" target="_blank" rel="noreferrer" style={{ color: '#7c3aed', fontWeight: 700 }}>gsm.rdpc.fr</a>.
      </div>
    </div>
  );
}

type ServeursSubTab = 'maj' | 'logs';

function ServeursTab({ isMobile }: { isMobile?: boolean }) {
  const [subTab, setSubTab] = useState<ServeursSubTab>('maj');
  const tabs: { key: ServeursSubTab; label: string }[] = [
    { key: 'maj', label: 'MAJ' },
    { key: 'logs', label: 'Logs' },
  ];
  return (
    <div style={{ maxWidth: 900, width: '100%', display: 'flex', flexDirection: 'column', gap: 20, boxSizing: 'border-box' }}>
      {isMobile ? (
        <select
          value={subTab}
          onChange={e => setSubTab(e.target.value as ServeursSubTab)}
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 14, fontWeight: 600, outline: 'none' }}
        >
          {tabs.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
      ) : (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {tabs.map(t => (
            <button key={t.key} onClick={() => setSubTab(t.key)} style={{
              padding: '7px 14px', borderRadius: 8, border: '1px solid',
              borderColor: subTab === t.key ? '#2563eb' : '#e2e8f0',
              background: subTab === t.key ? '#eff6ff' : '#fff',
              color: subTab === t.key ? '#2563eb' : '#64748b',
              fontSize: 13, fontWeight: subTab === t.key ? 600 : 400, cursor: 'pointer',
            }}>
              {t.label}
            </button>
          ))}
        </div>
      )}
      <div style={{ minWidth: 0 }}>
        {subTab === 'maj' && <MajTab isMobile={isMobile} />}
        {subTab === 'logs' && <LogsSubTab isMobile={isMobile} />}
      </div>
    </div>
  );
}

// ── Sous-onglet Logs de connexion ─────────────────────────

function _parseDevice(ua: string | null): string {
  if (!ua) return 'Inconnu';
  const u = ua.toLowerCase();
  let os = '';
  if (u.includes('android')) os = 'Android';
  else if (u.includes('iphone') || u.includes('ipad') || u.includes('ios')) os = 'iOS';
  else if (u.includes('windows')) os = 'Windows';
  else if (u.includes('mac os') || u.includes('macintosh')) os = 'macOS';
  else if (u.includes('linux')) os = 'Linux';
  let br = '';
  if (u.includes('edg/')) br = 'Edge';
  else if (u.includes('chrome') && !u.includes('edg/')) br = 'Chrome';
  else if (u.includes('firefox')) br = 'Firefox';
  else if (u.includes('safari') && !u.includes('chrome')) br = 'Safari';
  return [br, os].filter(Boolean).join(' · ') || 'Inconnu';
}

function LogsSubTab({ isMobile }: { isMobile?: boolean }) {
  const [logs, setLogs] = useState<ConnectionLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = async () => {
    setLoading(true); setErr('');
    try {
      const r = await getConnectionLogs(300);
      setLogs(r.data);
    } catch (e: any) {
      setErr(e?.response?.data?.detail || 'Impossible de charger les logs.');
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const fmt = (s: string) => {
    const d = new Date((s || '').replace(' ', 'T') + (s && s.includes('Z') ? '' : 'Z'));
    return isNaN(d.getTime()) ? s : d.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: isMobile ? 14 : '20px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#0f172a' }}>Connexions des utilisateurs</h3>
          <p style={{ margin: '4px 0 0', fontSize: 12.5, color: '#64748b' }}>Historique des connexions à l'application (300 dernières).</p>
        </div>
        <button onClick={load} disabled={loading} style={{ padding: '7px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#2563eb', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
          {loading ? '...' : '↻ Actualiser'}
        </button>
      </div>

      {err && <div style={{ color: '#dc2626', fontSize: 13 }}>{err}</div>}
      {!err && !loading && logs.length === 0 && (
        <div style={{ color: '#64748b', fontSize: 13, padding: 8 }}>Aucune connexion enregistrée pour le moment.</div>
      )}

      {logs.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: isMobile ? 12 : 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b', borderBottom: '1px solid #e2e8f0' }}>
                <th style={{ padding: '8px 10px', fontWeight: 600, whiteSpace: 'nowrap' }}>Date / heure</th>
                <th style={{ padding: '8px 10px', fontWeight: 600 }}>Utilisateur</th>
                <th style={{ padding: '8px 10px', fontWeight: 600, whiteSpace: 'nowrap' }}>Adresse IP</th>
                <th style={{ padding: '8px 10px', fontWeight: 600 }}>Navigateur / appareil</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', color: '#475569' }}>{fmt(l.created_at)}</td>
                  <td style={{ padding: '8px 10px', fontWeight: 600, color: '#0f172a' }}>{l.username || '—'}</td>
                  <td style={{ padding: '8px 10px', color: '#475569', fontFamily: 'monospace' }}>{l.ip || '—'}</td>
                  <td style={{ padding: '8px 10px', color: '#475569' }} title={l.user_agent || ''}>{_parseDevice(l.user_agent)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function MajTab({ isMobile }: { isMobile?: boolean }) {
  const [status, setStatus] = useState<MaintenanceStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState<string | null>(null);
  const [result, setResult] = useState<{ ok: boolean; message: string; output?: string } | null>(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await getMaintenanceStatus();
      setStatus(r.data);
    } catch {
      setResult({ ok: false, message: "Impossible de recuperer l'etat du serveur." });
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const actionLabels: Record<string, string> = {
    'backup-prod': 'Sauvegarder PROD',
    'pull-prod-db': 'Copier PROD vers DEV',
    'deploy-prod': 'Mettre a jour PROD',
  };

  const confirmations: Record<string, string> = {
    'backup-prod': 'Lancer une sauvegarde de la base de production ?',
    'pull-prod-db': 'Cette action va remplacer la base DEV par une copie de la base PROD. Continuer ?',
    'deploy-prod': 'Cette action va mettre a jour le programme sur SRV-PROD depuis DEV, sans copier la BDD. Continuer ?',
  };

  const runAction = async (actionId: string) => {
    if (!window.confirm(confirmations[actionId] || 'Lancer cette action ?')) return;
    setRunning(actionId);
    setResult(null);
    try {
      const r = await runMaintenanceAction(actionId);
      setResult({
        ok: true,
        message: r.data.message || 'Action terminee avec succes.',
        output: r.data.output,
      });
      await load();
    } catch (e: any) {
      const detail = e?.response?.data?.detail;
      setResult({
        ok: false,
        message: typeof detail === 'string' ? detail : detail?.message || "L'action a echoue.",
        output: detail?.output,
      });
    }
    setRunning(null);
  };

  const actions = status?.actions || {};
  const roleLabel = status?.role === 'production'
    ? 'Production'
    : status?.role === 'development'
      ? 'Developpement'
      : 'Inconnu';
  const fmtBytes = (bytes?: number | null) => {
    const b = bytes || 0;
    if (b >= 1024 ** 3) return `${(b / 1024 ** 3).toFixed(1)} Go`;
    if (b >= 1024 ** 2) return `${(b / 1024 ** 2).toFixed(1)} Mo`;
    if (b >= 1024) return `${(b / 1024).toFixed(1)} Ko`;
    return `${b} o`;
  };
  const fmtDate = (value?: string | null) => {
    if (!value) return '-';
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
  };
  const ServerCard = ({ title, server }: { title: string; server: any }) => {
    if (!server) {
      return (
        <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, color: '#94a3b8', fontSize: 13 }}>
          {title} indisponible
        </div>
      );
    }
    const disk = server.disk || {};
    const db = server.database || {};
    const used = Math.min(100, Math.max(0, Number(disk.used_percent || 0)));
    return (
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 14 }}>
          <div>
            <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8 }}>{title}</div>
            <div style={{ color: '#0f172a', fontSize: 16, fontWeight: 800, marginTop: 3 }}>{server.label || server.hostname}</div>
            <div style={{ color: '#64748b', fontSize: 12, marginTop: 2 }}>{server.ip || 'IP inconnue'}</div>
          </div>
          <div style={{ borderRadius: 999, padding: '5px 9px', background: server.role === 'production' ? '#fef2f2' : '#eff6ff', color: server.role === 'production' ? '#b91c1c' : '#2563eb', fontSize: 11, fontWeight: 800 }}>
            {server.role === 'production' ? 'PROD' : 'DEV'}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 12, color: '#64748b', marginBottom: 6 }}>
              <span>Disque utilise</span>
              <strong style={{ color: '#0f172a' }}>{fmtBytes(disk.used_bytes)} / {fmtBytes(disk.bytes)}</strong>
            </div>
            <div style={{ height: 8, borderRadius: 999, background: '#f1f5f9', overflow: 'hidden' }}>
              <div style={{ width: `${used}%`, height: '100%', background: used > 85 ? '#dc2626' : used > 70 ? '#f59e0b' : '#2563eb', borderRadius: 999 }} />
            </div>
            <div style={{ color: '#94a3b8', fontSize: 11, marginTop: 4 }}>{used.toFixed(1)}% utilise - {fmtBytes(disk.free_bytes)} libres</div>
          </div>
          <div style={{ background: '#f8fafc', border: '1px solid #f1f5f9', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6 }}>Base de donnees</div>
            <div style={{ color: '#0f172a', fontSize: 18, fontWeight: 800, marginTop: 3 }}>{fmtBytes(db.size_bytes)}</div>
            <div style={{ color: '#64748b', fontSize: 11, marginTop: 2 }}>Modifiee : {fmtDate(db.modified_at)}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ maxWidth: 980, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: isMobile ? 16 : 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: isMobile ? 'flex-start' : 'center', flexDirection: isMobile ? 'column' : 'row' }}>
          <div>
            <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6 }}>Serveur actuel</div>
            <div style={{ color: '#0f172a', fontSize: isMobile ? 22 : 26, fontWeight: 800 }}>{loading ? 'Chargement...' : status?.label || 'Serveur inconnu'}</div>
            <div style={{ color: '#64748b', fontSize: 13, marginTop: 4 }}>
              {status ? `${status.hostname} - ${status.ip || 'IP inconnue'}` : 'Etat indisponible'}
            </div>
          </div>
          <div style={{
            borderRadius: 999,
            padding: '8px 14px',
            background: status?.is_prod ? '#fef2f2' : status?.is_dev ? '#eff6ff' : '#f8fafc',
            color: status?.is_prod ? '#b91c1c' : status?.is_dev ? '#2563eb' : '#64748b',
            border: `1px solid ${status?.is_prod ? '#fecaca' : status?.is_dev ? '#bfdbfe' : '#e2e8f0'}`,
            fontSize: 13,
            fontWeight: 700,
          }}>
            {roleLabel}
          </div>
        </div>
        <div style={{ marginTop: 16, color: '#475569', fontSize: 13, lineHeight: 1.6 }}>
          Les actions de mise a jour sont disponibles uniquement depuis le serveur DEV. Sur PROD, cet onglet sert de controle visuel pour eviter une manipulation au mauvais endroit.
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: 14 }}>
        <ServerCard title="Serveur DEV" server={status?.local?.role === 'development' ? status.local : status?.role === 'development' ? status.local : null} />
        {status?.prod?.ok === false ? (
          <div style={{ background: '#fff', border: '1px solid #fecaca', borderRadius: 12, padding: 16 }}>
            <div style={{ color: '#b91c1c', fontSize: 13, fontWeight: 800 }}>Serveur PROD indisponible</div>
            <div style={{ color: '#64748b', fontSize: 12, marginTop: 6 }}>{status.prod.error || 'Impossible de lire les informations PROD.'}</div>
          </div>
        ) : (
          <ServerCard title="Serveur PROD" server={status?.prod || (status?.local?.role === 'production' ? status.local : null)} />
        )}
      </div>

      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: isMobile ? 'flex-start' : 'center', flexDirection: isMobile ? 'column' : 'row' }}>
          <div>
            <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>Etat de mise a jour PROD</div>
            <div style={{ color: status?.sync?.checked ? (status.sync.up_to_date ? '#16a34a' : '#f59e0b') : '#64748b', fontSize: 18, fontWeight: 900 }}>
              {!status?.sync?.checked ? 'Non verifie' : status.sync.up_to_date ? 'PROD est a jour' : 'PROD doit etre mis a jour'}
            </div>
            <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
              {!status?.sync?.checked
                ? (status?.sync?.reason || 'Verification disponible depuis DEV.')
                : status.sync.up_to_date
                  ? 'Aucune difference detectee sur le programme deployable.'
                  : `${status.sync.changes_count || 0} difference(s) detectee(s) entre DEV et PROD.`}
            </div>
          </div>
          <button onClick={load} disabled={loading || running !== null}
            style={{ padding: '9px 14px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 13, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Verification...' : 'Rafraichir'}
          </button>
        </div>
        {status?.sync?.checked && !status.sync.up_to_date && (status.sync.changes_sample || []).length > 0 && (
          <pre style={{ margin: '12px 0 0', whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 160, overflow: 'auto', color: '#334155', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: 10, fontSize: 11 }}>
            {(status.sync.changes_sample || []).join('\n')}
          </pre>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(0, 1fr))', gap: 14 }}>
        {(['backup-prod', 'pull-prod-db', 'deploy-prod'] as const).map(actionId => {
          const action = actions[actionId];
          const disabled = loading || running !== null || !action?.enabled;
          return (
            <div key={actionId} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, display: 'flex', flexDirection: 'column', gap: 12, minHeight: 190 }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#0f172a', fontSize: 15, fontWeight: 800, marginBottom: 8 }}>{action?.label || actionLabels[actionId]}</div>
                <div style={{ color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>{action?.description || 'Action indisponible.'}</div>
                {action?.disabled_reason && (
                  <div style={{ marginTop: 10, color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 10px', fontSize: 12 }}>
                    {action.disabled_reason}
                  </div>
                )}
              </div>
              <button
                onClick={() => runAction(actionId)}
                disabled={disabled}
                style={{
                  padding: '10px 14px',
                  borderRadius: 8,
                  border: 'none',
                  background: disabled ? '#e2e8f0' : actionId === 'pull-prod-db' ? '#f59e0b' : '#2563eb',
                  color: disabled ? '#94a3b8' : '#fff',
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: disabled ? 'not-allowed' : 'pointer',
                }}
              >
                {running === actionId ? 'Execution...' : actionLabels[actionId]}
              </button>
            </div>
          );
        })}
      </div>

      {result && (
        <div style={{
          background: result.ok ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${result.ok ? '#bbf7d0' : '#fecaca'}`,
          color: result.ok ? '#166534' : '#b91c1c',
          borderRadius: 12,
          padding: 14,
          fontSize: 13,
        }}>
          <div style={{ fontWeight: 700, marginBottom: result.output ? 10 : 0 }}>{result.message}</div>
          {result.output && (
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 260, overflow: 'auto', color: '#0f172a', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, fontSize: 12 }}>
              {result.output}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}

function TabBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick} style={{
      padding: '10px 18px', background: 'none', border: 'none',
      borderBottom: `2px solid ${active ? '#2563eb' : 'transparent'}`,
      color: active ? '#2563eb' : '#64748b',
      fontSize: 13, fontWeight: active ? 600 : 400,
      cursor: 'pointer', display: 'flex', alignItems: 'center',
      transition: 'all 0.15s', marginBottom: -1,
    }}>
      {children}
    </button>
  );
}

// ── Onglet Rémunération TikTok ────────────────────────────

type RemuTab = 'niveau' | 'activite' | 'progressif';

function RemunerationTab({ isMobile }: { isMobile?: boolean }) {
  const [sub, setSub] = useState<RemuTab>('niveau');

  const tabs: { key: RemuTab; label: string }[] = [
    { key: 'niveau', label: 'Montée de niveau' },
    { key: 'activite', label: 'Activité' },
    { key: 'progressif', label: 'Revenus progressifs' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {/* Sub-tabs */}
      {isMobile ? (
        <select
          value={sub}
          onChange={e => setSub(e.target.value as RemuTab)}
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: 14, fontWeight: 600, outline: 'none' }}
        >
          {tabs.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
      ) : (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {tabs.map(t => (
            <button key={t.key} onClick={() => setSub(t.key)} style={{
              padding: '7px 14px', borderRadius: 8, border: '1px solid',
              borderColor: sub === t.key ? '#2563eb' : '#e2e8f0',
              background: sub === t.key ? '#eff6ff' : '#fff',
              color: sub === t.key ? '#2563eb' : '#64748b',
              fontSize: 13, fontWeight: sub === t.key ? 600 : 400, cursor: 'pointer',
            }}>
              {t.label}
            </button>
          ))}
        </div>
      )}

      {sub === 'niveau' && <RemuNiveauTab isMobile={isMobile} />}
      {sub === 'activite' && <RemuActiviteTab isMobile={isMobile} />}
      {sub === 'progressif' && <RemuProgressifTab isMobile={isMobile} />}
    </div>
  );
}

const NIVEAU_DATA = [
  { niveau: 'Niveau 1',  seuil: '≥ 0',    montee: '7,5 %', maintien: '0 %',  nonMaintenu: '—'   },
  { niveau: 'Niveau 2',  seuil: '≥ 100K', montee: '7,5 %', maintien: '0 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 3',  seuil: '≥ 200K', montee: '7,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 4',  seuil: '≥ 300K', montee: '7,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 5',  seuil: '≥ 500K', montee: '7,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 6',  seuil: '≥ 700K', montee: '6,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 7',  seuil: '≥ 1M',   montee: '5,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 8',  seuil: '≥ 1,6M', montee: '4,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 9',  seuil: '≥ 2,5M', montee: '3,5 %', maintien: '4 %',  nonMaintenu: '0 %' },
  { niveau: 'Niveau 10', seuil: '≥ 5M',   montee: '—',     maintien: '4 %',  nonMaintenu: '0 %' },
];

function RemuNiveauTab({ isMobile }: { isMobile?: boolean }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <RemuCard title="Incitation à la montée de niveau" subtitle="Échelon du mois dernier">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: isMobile ? 12 : 13 }}>
            <thead>
              <tr>
                <th rowSpan={2} style={thCell}>Niveau</th>
                <th rowSpan={2} style={thCell}>Diamants</th>
                <th colSpan={3} style={{ ...thCell, textAlign: 'center', background: '#f0f9ff', color: '#0369a1', borderBottom: '1px solid #bae6fd' }}>Taux</th>
              </tr>
              <tr>
                <th style={{ ...thCell, background: '#f0fdf4', color: '#15803d' }}>Montée de niveau</th>
                <th style={{ ...thCell, background: '#fefce8', color: '#a16207' }}>Maintien de niveau</th>
                <th style={{ ...thCell, background: '#fef2f2', color: '#b91c1c' }}>Échelon non maintenu</th>
              </tr>
            </thead>
            <tbody>
              {NIVEAU_DATA.map((r, i) => (
                <tr key={r.niveau} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ ...tdCell, fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap' }}>{r.niveau}</td>
                  <td style={{ ...tdCell, color: '#374151' }}>{r.seuil}</td>
                  <td style={{ ...tdCell, textAlign: 'center', fontWeight: 600, color: r.montee === '—' ? '#94a3b8' : '#15803d' }}>{r.montee}</td>
                  <td style={{ ...tdCell, textAlign: 'center', fontWeight: 600, color: r.maintien === '0 %' ? '#94a3b8' : '#a16207' }}>{r.maintien}</td>
                  <td style={{ ...tdCell, textAlign: 'center', color: r.nonMaintenu === '—' ? '#94a3b8' : '#b91c1c' }}>{r.nonMaintenu}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </RemuCard>

      <RemuCard title="Conditions d'éligibilité">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Et</div>
          <ConditionBadge label="Condition 1" text="Jours de passage en LIVE valides mensuels ≥ 7 jours" />
          <ConditionBadge label="Condition 2" text="Durée mensuelle de LIVE ≥ 15 heures" />
        </div>
      </RemuCard>

      <RemuCard title="Augmentation ou maintien d'échelon">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13, color: '#374151', lineHeight: 1.6 }}>
          <p style={{ margin: 0 }}><strong>1. Échelons :</strong> le total des Diamants des créateurs au cours du dernier mois (qu'ils étaient dans l'agence ou non) détermine leurs échelons au cours du dernier mois. Le total des Diamants des créateurs dans l'agence durant le mois en cours détermine leurs échelons pendant le mois en cours.</p>
          <p style={{ margin: 0 }}><strong>2. Augmentation d'échelon :</strong> l'échelon du créateur durant le mois en cours est plus élevé que celui du mois dernier.</p>
          <p style={{ margin: 0 }}><strong>3. Maintien d'échelon :</strong> l'échelon du créateur durant le mois en cours est le même que celui du mois dernier. Pour récupérer un bonus de maintien, le total des Diamants du mois en cours doit être au moins égal à <strong>80 %</strong> de celui du mois dernier.</p>
        </div>
      </RemuCard>
    </div>
  );
}

const ACTIVITE_DATA = [
  { niveau: 'Niveau 1', diamonds: '≥ 100', jours: '≥ 8',  duree: '≥ 20h', taux: '0,5 %' },
  { niveau: 'Niveau 2', diamonds: '≥ 100', jours: '≥ 11', duree: '≥ 30h', taux: '1 %'   },
  { niveau: 'Niveau 3', diamonds: '≥ 100', jours: '≥ 15', duree: '≥ 40h', taux: '2 %'   },
  { niveau: 'Niveau 4', diamonds: '≥ 100', jours: '≥ 18', duree: '≥ 60h', taux: '2,5 %' },
  { niveau: 'Niveau 5', diamonds: '≥ 100', jours: '≥ 22', duree: '≥ 80h', taux: '3,5 %' },
];

function RemuActiviteTab({ isMobile }: { isMobile?: boolean }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <RemuCard title="Incitation à l'activité" subtitle="Le bonus augmente avec le nombre de jours et le temps passé en LIVE">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: isMobile ? 12 : 13 }}>
            <thead>
              <tr>
                <th style={thCell}>Niveau</th>
                <th style={thCell}>Diamants mensuels</th>
                <th style={thCell}>Jours LIVE valides</th>
                <th style={thCell}>Durée mensuelle LIVE</th>
                <th style={{ ...thCell, background: '#f0fdf4', color: '#15803d' }}>Taux de bonus</th>
              </tr>
            </thead>
            <tbody>
              {ACTIVITE_DATA.map((r, i) => (
                <tr key={r.niveau} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ ...tdCell, fontWeight: 600, color: '#0f172a' }}>{r.niveau}</td>
                  <td style={{ ...tdCell, textAlign: 'center' }}>{r.diamonds}</td>
                  <td style={{ ...tdCell, textAlign: 'center' }}>{r.jours}</td>
                  <td style={{ ...tdCell, textAlign: 'center' }}>{r.duree}</td>
                  <td style={{ ...tdCell, textAlign: 'center', fontWeight: 700, color: '#15803d' }}>{r.taux}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </RemuCard>

      <RemuCard title="Conditions d'éligibilité">
        <p style={{ margin: 0, fontSize: 13, color: '#374151' }}>Tous les hôtes dans l'agence.</p>
      </RemuCard>
    </div>
  );
}

const PROGRESSIF_DATA = [
  { niveau: 1,  taux: '≥ 70 %',  bonus: '2 %'  },
  { niveau: 2,  taux: '≥ 75 %',  bonus: '3 %'  },
  { niveau: 3,  taux: '≥ 80 %',  bonus: '4 %'  },
  { niveau: 4,  taux: '≥ 85 %',  bonus: '5 %'  },
  { niveau: 5,  taux: '≥ 90 %',  bonus: '7 %'  },
  { niveau: 6,  taux: '≥ 95 %',  bonus: '8 %'  },
  { niveau: 7,  taux: '≥ 100 %', bonus: '9 %'  },
  { niveau: 8,  taux: '≥ 105 %', bonus: '10 %' },
  { niveau: 9,  taux: '≥ 110 %', bonus: '11 %' },
  { niveau: 10, taux: '≥ 115 %', bonus: '12 %' },
  { niveau: 11, taux: '≥ 120 %', bonus: '13 %' },
  { niveau: 12, taux: '≥ 125 %', bonus: '14 %' },
  { niveau: 13, taux: '≥ 130 %', bonus: '15 %' },
];

function fmtMonthKey(key: string): string {
  const [y, m] = key.split('-');
  try {
    const d = new Date(parseInt(y), parseInt(m) - 1);
    const label = d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    return label.charAt(0).toUpperCase() + label.slice(1);
  } catch { return key; }
}

function RemuProgressifTab({ isMobile }: { isMobile?: boolean }) {
  const [refValue, setRefValue] = useState('');
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  // Table par mois
  const [months, setMonths] = useState<string[]>([]);
  const [monthRefs, setMonthRefs] = useState<Record<string, string>>({});
  const [editingMonth, setEditingMonth] = useState<string | null>(null);
  const [monthDraft, setMonthDraft] = useState('');
  const [monthSaving, setMonthSaving] = useState(false);

  const loadAll = async () => {
    try {
      const [sRes, pRes] = await Promise.all([getSettings(), getPeriods()]);
      const d = sRes.data;
      setRefValue(d['remuneration_ref_diamonds'] ?? '824,46K');
      // Mois uniques (du plus récent au plus ancien)
      const seen = new Set<string>();
      const uniq: string[] = [];
      for (const p of pRes.data) {
        const mk = p.match(/^(\d{4}-\d{2})/)?.[1];
        if (mk && !seen.has(mk)) { seen.add(mk); uniq.push(mk); }
      }
      setMonths(uniq);
      const refs: Record<string, string> = {};
      for (const mk of uniq) refs[mk] = d[`remuneration_ref_diamonds_${mk}`] || '';
      setMonthRefs(refs);
    } catch {}
  };

  useEffect(() => { loadAll(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleEdit = () => { setDraft(refValue); setEditing(true); };
  const handleCancel = () => setEditing(false);
  const handleSave = async () => {
    if (!draft.trim()) return;
    setSaving(true);
    try {
      await setSetting('remuneration_ref_diamonds', draft.trim());
      setRefValue(draft.trim());
      setEditing(false);
    } catch {}
    setSaving(false);
  };

  const handleMonthEdit = (mk: string) => { setEditingMonth(mk); setMonthDraft(monthRefs[mk] || ''); };
  const handleMonthCancel = () => setEditingMonth(null);
  const handleMonthSave = async () => {
    if (!editingMonth) return;
    setMonthSaving(true);
    try {
      await setSetting(`remuneration_ref_diamonds_${editingMonth}`, monthDraft.trim());
      setMonthRefs(prev => ({ ...prev, [editingMonth]: monthDraft.trim() }));
      setEditingMonth(null);
    } catch {}
    setMonthSaving(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <RemuCard title="Incitation aux revenus progressifs">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, padding: '12px 16px', background: '#f0f9ff', borderRadius: 10, border: '1px solid #bae6fd' }}>
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#0369a1" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 11, color: '#0369a1', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.6 }}>Valeur de référence Diamants</div>
            {editing ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                <input
                  autoFocus
                  value={draft}
                  onChange={e => setDraft(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') handleSave(); if (e.key === 'Escape') handleCancel(); }}
                  style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', border: '2px solid #2563eb', borderRadius: 8, padding: '3px 10px', outline: 'none', width: 140, background: '#fff' }}
                />
                <button onClick={handleSave} disabled={saving} style={{ padding: '4px 12px', borderRadius: 7, border: 'none', background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                  {saving ? '…' : 'OK'}
                </button>
                <button onClick={handleCancel} style={{ padding: '4px 8px', borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: 13, cursor: 'pointer' }}>
                  ✕
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 2 }}>
                <span style={{ fontSize: 20, fontWeight: 700, color: '#0f172a' }}>{refValue} 💎</span>
                <button onClick={handleEdit} title="Modifier la valeur de référence"
                  style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 7, border: '1px solid #bae6fd', background: '#fff', color: '#0369a1', fontSize: 12, fontWeight: 500, cursor: 'pointer' }}>
                  <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                  Modifier
                </button>
              </div>
            )}
          </div>
        </div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>Un taux d'achèvement plus élevé de la valeur de référence engendre un taux de bonus plus élevé.</div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: isMobile ? 12 : 13 }}>
            <thead>
              <tr>
                <th style={thCell}>Niveau</th>
                <th style={thCell}>Taux d'achèvement de l'objectif</th>
                <th style={{ ...thCell, background: '#f0fdf4', color: '#15803d' }}>Taux de bonus</th>
              </tr>
            </thead>
            <tbody>
              {PROGRESSIF_DATA.map((r, i) => (
                <tr key={r.niveau} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ ...tdCell, fontWeight: 600, color: '#0f172a', textAlign: 'center' }}>{r.niveau}</td>
                  <td style={{ ...tdCell, textAlign: 'center', color: '#374151' }}>{r.taux}</td>
                  <td style={{ ...tdCell, textAlign: 'center', fontWeight: 700, color: '#15803d' }}>{r.bonus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </RemuCard>

      <RemuCard title="Conditions d'éligibilité">
        <p style={{ margin: 0, fontSize: 13, color: '#374151', lineHeight: 1.6 }}>
          Les créateur(trice)s ayant rejoint l'agence via la fonctionnalité « Découvrir des créateurs / découvrir des agences » ou « Entrée spéciale - Transfer » tout en ayant dépassé le seuil de revenus d'entrée ne seront pas comptabilisé(e)s pour le mois en question.
        </p>
      </RemuCard>

      {/* ── Références par mois ── */}
      {months.length > 0 && (
        <RemuCard title="Valeurs de référence par mois" subtitle="Prioritaires sur la valeur globale ci-dessus">
          <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>
            Saisissez la valeur cible de diamants pour chaque mois importé. Ex : <strong>824460</strong> ou <strong>824,46K</strong>. Si vide, la valeur globale est utilisée.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0, border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' }}>
            {months.map((mk, i) => {
              const isEditing = editingMonth === mk;
              const val = monthRefs[mk] || '';
              return (
                <div key={mk} style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
                  background: isEditing ? '#eff6ff' : i % 2 === 0 ? '#fff' : '#f8fafc',
                  borderTop: i > 0 ? '1px solid #f1f5f9' : 'none',
                  transition: 'background 0.1s',
                }}>
                  <span style={{ flex: '0 0 130px', fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{fmtMonthKey(mk)}</span>
                  {isEditing ? (
                    <>
                      <input
                        autoFocus
                        value={monthDraft}
                        onChange={e => setMonthDraft(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') handleMonthSave(); if (e.key === 'Escape') handleMonthCancel(); }}
                        placeholder="ex: 824460"
                        style={{ flex: 1, padding: '5px 10px', borderRadius: 7, border: '2px solid #2563eb', fontSize: 13, outline: 'none', background: '#fff' }}
                      />
                      <button onClick={handleMonthSave} disabled={monthSaving}
                        style={{ padding: '5px 12px', borderRadius: 7, border: 'none', background: '#2563eb', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        {monthSaving ? '…' : 'OK'}
                      </button>
                      <button onClick={handleMonthCancel}
                        style={{ padding: '5px 8px', borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: 12, cursor: 'pointer' }}>
                        ✕
                      </button>
                    </>
                  ) : (
                    <>
                      <span style={{ flex: 1, fontSize: 13, color: val ? '#0f172a' : '#94a3b8', fontWeight: val ? 600 : 400 }}>
                        {val ? `${val} 💎` : '— (valeur globale)'}
                      </span>
                      <button onClick={() => handleMonthEdit(mk)}
                        style={{ padding: '4px 10px', borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', color: '#374151', fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <svg width="11" height="11" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                        {val ? 'Modifier' : 'Définir'}
                      </button>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </RemuCard>
      )}
    </div>
  );
}

// ── Onglet Objectifs agence ───────────────────────────────

function ObjectifsTab({ isMobile }: { isMobile?: boolean }) {
  const [form, setForm] = useState({ days: '8', hours: '20', diamonds: '750' });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getSettings().then(r => {
      const d = r.data;
      setForm({
        days:     d['objective_days']     || '8',
        hours:    d['objective_hours']    || '20',
        diamonds: d['objective_diamonds'] || '750',
      });
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await setSetting('objective_days',     form.days);
      await setSetting('objective_hours',    form.hours);
      await setSetting('objective_diamonds', form.diamonds);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch {}
    setSaving(false);
  };

  return (
    <div style={{ maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9', background: '#fafbfc' }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>Objectifs mensuels</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
            Ces seuils servent à évaluer la performance de chaque liver dans la liste.
          </div>
        </div>
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 18 }}>

          {/* Jours */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div>
                <div style={{ color: '#374151', fontSize: 13, fontWeight: 600 }}>📅 Jours de live</div>
                <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 1 }}>Nombre minimum de jours en live dans le mois</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="number" min="1" max="31"
                  value={form.days}
                  onChange={e => setForm(f => ({ ...f, days: e.target.value }))}
                  style={{ ...inputLight, width: 80, textAlign: 'center', fontWeight: 700, fontSize: 16 }}
                />
                <span style={{ color: '#64748b', fontSize: 13 }}>jours</span>
              </div>
            </div>
            <ObjectiveBar value={parseInt(form.days) || 0} max={31} color="#2563eb" />
          </div>

          {/* Heures */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div>
                <div style={{ color: '#374151', fontSize: 13, fontWeight: 600 }}>⏱ Heures de live</div>
                <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 1 }}>Durée totale cumulée de live dans le mois</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="number" min="1" max="744"
                  value={form.hours}
                  onChange={e => setForm(f => ({ ...f, hours: e.target.value }))}
                  style={{ ...inputLight, width: 80, textAlign: 'center', fontWeight: 700, fontSize: 16 }}
                />
                <span style={{ color: '#64748b', fontSize: 13 }}>heures</span>
              </div>
            </div>
            <ObjectiveBar value={parseInt(form.hours) || 0} max={200} color="#7c3aed" />
          </div>

          {/* Diamants */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div>
                <div style={{ color: '#374151', fontSize: 13, fontWeight: 600 }}>💎 Diamants</div>
                <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 1 }}>Nombre minimum de diamants collectés dans le mois</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="number" min="0"
                  value={form.diamonds}
                  onChange={e => setForm(f => ({ ...f, diamonds: e.target.value }))}
                  style={{ ...inputLight, width: 90, textAlign: 'center', fontWeight: 700, fontSize: 16 }}
                />
                <span style={{ color: '#64748b', fontSize: 13 }}>💎</span>
              </div>
            </div>
            <ObjectiveBar value={parseInt(form.diamonds) || 0} max={5000} color="#ea580c" />
          </div>

        </div>
      </div>

      {/* Légende */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>Indicateurs dans la liste des streamers</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <LegendItem icon="✅" color="#16a34a" label="Les 3 objectifs sont atteints" />
          <LegendItem icon="⚠️" color="#ea580c" label="Au moins 1 objectif atteint (partiel)" />
          <LegendItem icon="❌" color="#dc2626" label="Aucun objectif atteint" />
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={handleSave} disabled={saving}
          style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}>
          {saving ? 'Sauvegarde…' : 'Sauvegarder'}
        </button>
        {saved && <span style={{ color: '#16a34a', fontSize: 13, fontWeight: 500 }}>✓ Sauvegardé</span>}
      </div>
    </div>
  );
}

function ObjectiveBar({ value, max, color }: { value: number; max: number; color: string }) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div style={{ height: 4, borderRadius: 4, background: '#f1f5f9', overflow: 'hidden' }}>
      <div style={{ height: '100%', borderRadius: 4, background: color, width: `${pct}%`, transition: 'width 0.3s' }} />
    </div>
  );
}

function LegendItem({ icon, color, label }: { icon: string; color: string; label: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{icon}</span>
      <span style={{ color: '#64748b', fontSize: 13 }}>{label}</span>
    </div>
  );
}

// ── Onglet Rémunération ───────────────────────────────────

function RemuCard({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
  return (
    <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9', background: '#fafbfc' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{title}</div>
        {subtitle && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{subtitle}</div>}
      </div>
      <div style={{ padding: '16px 20px' }}>{children}</div>
    </div>
  );
}

function ConditionBadge({ label, text }: { label: string; text: string }) {
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 14px', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: '#2563eb', background: '#eff6ff', padding: '2px 8px', borderRadius: 20, whiteSpace: 'nowrap', flexShrink: 0 }}>{label}</span>
      <span style={{ fontSize: 13, color: '#374151' }}>{text}</span>
    </div>
  );
}

const thCell: React.CSSProperties = {
  padding: '10px 12px', textAlign: 'left', fontSize: 11, fontWeight: 700,
  color: '#64748b', background: '#f8fafc', textTransform: 'uppercase',
  letterSpacing: 0.5, border: '1px solid #e2e8f0', whiteSpace: 'nowrap',
};
const tdCell: React.CSSProperties = {
  padding: '9px 12px', border: '1px solid #f1f5f9', color: '#374151', verticalAlign: 'middle',
};

// ── Fin Rémunération ──────────────────────────────────────

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ color: '#374151', fontSize: 13, fontWeight: 500 }}>{label}</div>
      {children}
    </div>
  );
}

const inputLight: React.CSSProperties = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: '1px solid #e2e8f0', background: '#fff',
  color: '#0f172a', fontSize: 13, boxSizing: 'border-box', outline: 'none',
};

const btnSecondary: React.CSSProperties = {
  padding: '9px 16px', borderRadius: 8, border: '1px solid #e2e8f0',
  background: '#fff', color: '#374151', fontSize: 13, cursor: 'pointer',
};

export { };
